const MODULE_NAME = 'fulcrum/container/Project/NvbugsSection'

const FETCH_NVBUGS = MODULE_NAME + '/FETCH_NVBUGS'
const FETCH_NVBUGS_START = MODULE_NAME + '/FETCH_NVBUGS_START'
const FETCH_NVBUGS_SUCCESS = MODULE_NAME + '/FETCH_NVBUGS_SUCCESS'
const FETCH_NVBUGS_ERROR = MODULE_NAME + '/FETCH_NVBUGS_ERROR'

const UPDATE_NVBUGS = MODULE_NAME + '/UPDATE_NVBUGS'

const ADD_TABLE_FILTER = MODULE_NAME + '/ADD_TABLE_FILTER'
const ADD_TABLE_SORT = MODULE_NAME + '/ADD_TABLE_SORT'
const CLEAR_FILTERS = MODULE_NAME + '/CLEAR_FILTERS'

const FETCH_LIMIT = 25

const SHOW_INITAL_LENGTH = 4

const BUG_ACTION_LABELS = [
  ['to fix', 'toFix'],
  ['to verify', 'toVerify'],
  ['to close', 'toClose'],
  ['closed', 'closed'],
  ['', 'other']
]

const TABLE_HEAD_CONTENT = Object.freeze({
  bugId: 'NVBugs ID',
  synopsis: 'Synopsis',
  category: 'Category',
  moduleName: 'Module',
  bugAction: 'Bug Action'
})

export {
  MODULE_NAME,
  FETCH_NVBUGS,
  FETCH_NVBUGS_START,
  FETCH_NVBUGS_SUCCESS,
  FETCH_NVBUGS_ERROR,
  UPDATE_NVBUGS,
  FETCH_LIMIT,
  SHOW_INITAL_LENGTH,
  BUG_ACTION_LABELS,
  TABLE_HEAD_CONTENT,
  ADD_TABLE_FILTER,
  ADD_TABLE_SORT,
  CLEAR_FILTERS
}
